import { gql } from "@apollo/client";

export const RegistrationStatusPostbackTypeDef = gql`
  enum RegistrationStatusPostback {
    Approved
    Declined
    Deposited
    PendingApproved
    PendingDeposited
    PendingRegistered
    Registered
  }
`;
